import * as Sentry from "@sentry/vue";
import { API_ENDPOINTS } from "@utils/api/endpoints";

export default async function (idPost) {
  const routeLang = useRouteLang();

  try {
    return await $apiFetch(API_ENDPOINTS.CONTENT_POST_ID_TRANSLATION, {
      method: 'GET',
      path: { idPost },
      params: {
        locale: routeLang.locale.value
      }
    });
  } catch (error) {
    Sentry.captureException(error);
  }

  return null;
}
